module.exports = __webpack_public_path__ + "img/marker.5a8c57f4.png";